import { useEffect } from "react";
import { API_OPTIONS } from "../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { addPopularMovies } from "../utils/movieSlice";
const usePopular = () => {
  const dispatch = useDispatch();
  const popularMovies = useSelector((store) => store.movies.popularMovies);

  const url = "https://api.themoviedb.org/3/movie/popular?page=1";

  async function getPopularMovies() {
    try {
      const response = await axios.get(url, API_OPTIONS);
      let responseOK = response && response.status === 200;

      if (responseOK) {
        const data = await response.data;
        dispatch(addPopularMovies(data.results));
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    !popularMovies && getPopularMovies();
  }, []);
};

export default usePopular;
